export enum SelectClinicsSortingKeysEnum {
    clinicId="clinicId",
    ClinicName="ClinicName"
}
